import React from 'react';
import { FieldValues, Path } from 'react-hook-form';
import { IntegrationType, integrationTypes } from '../../../schemas/cameras';
import { translate } from '../../../services/translate';
import CheckboxList from '../CheckboxList';

function CameraIntegrationTypeList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    return <CheckboxList
        name={name}
        items={integrationTypes.map(type => ({
            label: translate(type),
            value: type,
            tooltipText: translate(type === 'type_1' ? 'type1Info' : type === 'type_2' ? 'type2Info' : 'type3Info'),
        }))}
    />;
}

CameraIntegrationTypeList.getCount = (value: IntegrationType[]) => value.length;

export default CameraIntegrationTypeList;
